import { getInfo } from '@/api/index'
import { getToken, removeToken, getVisitorToken, setToken } from '@/utils/auth'

let info = localStorage.getItem('info')
info = info ? JSON.parse(info) : {}
const subjectType = localStorage.getItem('subjectType') || ''
const invitationSource = localStorage.getItem('invitationSource')
const curToken = getToken()
const visitorToken = getVisitorToken()
const isLogin = function() {
  // 通过对比token 且 是否时登录状态 来判断是否登录
  // return getToken() && getToken() !== getVisitorToken() && localStorage.getItem('isLogin') === '1'
  return info.id && ['VISITOR','ACTOR'].includes(subjectType) && curToken && curToken !== visitorToken && localStorage.getItem('isLogin') === '1'
}

const user = {
  state: {
    token: getToken(),
    //用户信息
    info: info,
    //角色类型
    subjectType: localStorage.getItem('subjectType') || '',
    //展会id
    exhibitionId: localStorage.getItem('exhibitionId') || '',
    //语言
    language: localStorage.getItem('language') || 'zh',
    //存储之前的本地语言
    languageOld: localStorage.getItem('languageOld') || localStorage.getItem('language') || 'zh',
    //用户名
    name: localStorage.getItem('name'), // '--'
    //展商id
    exhibitorId: localStorage.getItem('exhibitorId') || '',
    //客商id
    visitorId: localStorage.getItem('visitorId') || '',
    //登录状态
    isLogin: isLogin(),
    //来源
    fromUrl: localStorage.getItem('fromUrl') || '',
    //邀请函来源
    invitationSource: invitationSource ? JSON.parse(invitationSource) : null,
    //广告位分享来源的地址
    advertisingSharing: localStorage.getItem('advertisingSharing') || '',
    // 邀约时弹出提示
    inviteType: sessionStorage.getItem('inviteType') || '',
    // 是否已设置用户信息
    setuserinfo: sessionStorage.getItem('setuserinfo') || 'n',
    // 是否腾讯IM
    isTIM: true,
    // 用户头像
    heading: '',
  },

  mutations: {
    SET_USER_INFO: (state, setuserinfo) => {
      state.setuserinfo = setuserinfo
      sessionStorage.setItem('setuserinfo', setuserinfo)
    },
    SET_TOKEN: (state, token) => {

      if (token === 'null' || token === 'undefined' || token === undefined || token === null || token === '') {
        state.token = visitorToken
      } else {
        state.token = token
      }
      setToken(state.token)
    },
    // SET_TOKEN: (state, token) => {
    //   state.token = token
    // },
    SET_INFO: (state, info) => {
        state.info = info || {}
        if (!info) {
          localStorage.removeItem('info')
          window.PC.$RangersConfigInit(state, 'clear')
        } else {
          localStorage.setItem('info', JSON.stringify(info))
          if (info.userAccountId) {
              window.PC.$RangersConfigInit(state, 'change')
          }
        }
    },
    SET_NAME: (state, name) => {
      state.name = name
      if (!name) {
        localStorage.removeItem('name')
      } else {
        localStorage.setItem('name', name)
      }
    },
    SET_SUBJECTTYPE: (state, subjectType) => {
      state.subjectType = subjectType
      const identity = localStorage.getItem('subjectType') || ''
      /**
       * 本地身份与设置身份不一样
       * 且 非 (本地身份为客商 设置身份为空 或者 本地身份为空 设置身份为客商)
       * 不需要修改dataFinder的config配置
       */
      if (identity != subjectType && !(subjectType === 'VISITOR' && identity === '' || subjectType === '' && identity === 'VISITOR')) {
        window.PC.$RangersConfigInit(state, 'changeIdentity')
      }
      if (!subjectType) {
        localStorage.removeItem('subjectType')
      } else {
        localStorage.setItem('subjectType', subjectType)
      }
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      localStorage.setItem('language', language)
    },
    SET_LANGUAGE_OLD: (state, language) => {
      state.languageOld = language
      localStorage.setItem('languageOld', language)
    },
    SET_EXHIBITIONID: (state, exhibitionId) => {
      state.exhibitionId = exhibitionId
      if (!exhibitionId) {
        localStorage.removeItem('exhibitionId')
      } else {
        localStorage.setItem('exhibitionId', exhibitionId)
      }
    },
    SET_EXHIBITORID: (state, exhibitorId) => {
      state.exhibitorId = exhibitorId
      if (!exhibitorId) {
        localStorage.removeItem('exhibitorId')
      } else {
        localStorage.setItem('exhibitorId', exhibitorId)
      }
    },
    SET_VISITORID: (state, visitorId) => {
      state.visitorId = visitorId
      if (!visitorId) {
        localStorage.removeItem('visitorId')
      } else {
        localStorage.setItem('visitorId', visitorId)
      }
    },
    SET_ISLOGIN: (state, isLogin) => {
      if (isLogin !== '1') {
        state.isLogin = false
        localStorage.removeItem('isLogin')
      } else {
        state.isLogin = true
        localStorage.setItem('isLogin', '1')
      }
    },
    SET_FROMURL: (state, fromUrl) => {
      state.fromUrl = fromUrl
      if (!fromUrl) {
        localStorage.removeItem('fromUrl')
      } else {
        localStorage.setItem('fromUrl', fromUrl)
      }
    },
    SET_INVITATION_SOURCE: (state, invitationSource) => {
      state.invitationSource = invitationSource
      if (!invitationSource) {
        localStorage.removeItem('invitationSource')
      } else {
        localStorage.setItem('invitationSource', JSON.stringify(invitationSource))
      }
    },
    SET_ADVERTISING_SHARING: (state, advertisingSharing) => {
      state.advertisingSharing = advertisingSharing
      if (!advertisingSharing) {
        localStorage.removeItem('advertisingSharing')
      } else {
        localStorage.setItem('advertisingSharing', advertisingSharing)
      }
    },
    SET_INVITETYPE(state,data){
      state.inviteType = data
    },
    SET_HEADIMG(state, data) {
      state.heading = data
    }
  },

  actions: {
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token)
          .then(res => {
            const info = res.user
            if (res.subjectType) {
              commit('SET_SUBJECTTYPE', res.roles)
            }
            commit('SET_INFO', info)
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 退出系统
    LogOut({ dispatch, rootState, commit, store }) {
      // eslint-disable-next-line no-async-promise-executor
      console.log('======== LogOut store user ======')
      return new Promise(async (resolve) => {
        await dispatch('ClearUserStore')
        console.log('rootState.sendingUser--->', window.$TIM, store)
        if (rootState.sendingUser) {
          await dispatch('chatLogout')
        }



        await removeToken()
        sessionStorage.clear()
        resolve()
        console.log('getToken--->', getToken())
        const visitorToken = getVisitorToken();
        
        await setToken(visitorToken)
        await window.$TIM.logout().then(async () => {
          await commit('toggleIsLogin')
          await commit('reset')
          await dispatch('getOnlineCustomer', false)
        }).catch((err) => {
          console.log('err---->333--->', err)
        })

      })
    },

    // 清空所有有关的user信息
    ClearUserStore: async ({ commit }) => {
      await commit('SET_TOKEN', '')
      await commit('SET_SUBJECTTYPE', '')
      await commit('SET_INFO', null)
      await commit('SET_NAME', '')
      await commit('SET_EXHIBITORID', '')
      await commit('SET_VISITORID', '')
      await commit('SET_ISLOGIN', '')
      await commit('SET_CONFIGSWITCH', '')
      // await commit('setTouristService', null)
      // commit('SET_FROMURL', '')
      // commit('SET_INVITATION_SOURCE', null)
      // commit('SET_ADVERTISING_SHARING', '')
      await commit('SET_LOGIN_TYPE', '')
      await commit('SET_LOGIN_ACCOUNT', '')
      sessionStorage.removeItem('setuserinfo')
    },

    // 登录成功后设置信息
    BaseInfo({ commit, state }, data) {
      commit('SET_INFO', data.exhibitionUserRegister)
      commit('SET_SUBJECTTYPE', data.exhibitionUserRegister.subjectType)
      commit('SET_EXHIBITIONID', data.exhibitionUserRegister.exhibitionId)
      commit('SET_ISLOGIN', '1')
      if (state.subjectType == 'ACTOR') {
        commit('SET_NAME', data.exhibitionUserRegister.userInfo.name)
        commit('SET_EXHIBITORID', data.exhibitionUserRegister.exhibitorEmployee.exhibitorId)
      } else {
        commit('SET_NAME', data.exhibitionUserRegister.visitor.name)
        commit('SET_VISITORID', data.exhibitionUserRegister.visitor.id)
      }
    }
  }
}

export default user
